/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Back_GenericInputs */

const tr_katalog_desi_page_back_generic = /** @type {(inputs: Katalog_Desi_Page_Back_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri dön`)
};

const en_katalog_desi_page_back_generic = /** @type {(inputs: Katalog_Desi_Page_Back_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back`)
};

const de_katalog_desi_page_back_generic = /** @type {(inputs: Katalog_Desi_Page_Back_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const ru_katalog_desi_page_back_generic = /** @type {(inputs: Katalog_Desi_Page_Back_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

/**
* | output |
* | --- |
* | "Go back" |
*
* @param {Katalog_Desi_Page_Back_GenericInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_back_generic = /** @type {((inputs?: Katalog_Desi_Page_Back_GenericInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Back_GenericInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_back_generic(inputs)
	if (locale === "de") return de_katalog_desi_page_back_generic(inputs)
	if (locale === "ru") return ru_katalog_desi_page_back_generic(inputs)
	return tr_katalog_desi_page_back_generic(inputs)
});